import Vue from "vue";
//路由配置
import VueRouter from "vue-router";
import pc from '../components/pc/pc.vue'
import pcIndex from '../components/pc/index.vue'
import mobile from '../components/mobile/mobile.vue'
import mobileIndex from '../components/mobile/index.vue'
import container from '../components/container.vue'

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
return originalPush.call(this, location).catch(err => err)
}
Vue.use(VueRouter);


const routes = [
  {
    path: '/pc',
    name:'pc',
    component: pc,
    children:[{
      path: '/',
      name: pcIndex
    }]
  },
  {
    path: '/mobile', // 手机端首页
    name:'mobile',
    component: mobile,
    children:[{
      path: '/',
      name: mobileIndex
    }]
  },
  {
    path: '/container', // 手机端首页
    name:'container',
    component: container,
  }
]; 

const router = new VueRouter({
  routes
});
/*router.beforeEach((to, from, next) => {
//NProgress.start()
 if (navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)) {
  if (to.path.indexOf('/mi') !==-1) {
      next({path: to.path.replace('/home-mobile', '/test')})
    }
} else {
   if (to.path.indexOf('/test') !== -1) {
      next({path: to.path.replace('/home', '/mi')})
   }
 }
next()
}) */
/* router.afterEach(() => {
  //   NProgress.done();
}) */

export default router;